var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHebLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 36,
    viewBox: "0 0 116 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.0148 36C107.948 36 116 27.9411 116 18C116 8.05887 107.948 0 98.0148 0L17.9774 0.0154858C8.04876 0.0154858 0 8.07089 0 18.0077C0 27.9446 8.04876 36 17.9774 36H98.0148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0147 34.2214C106.972 34.2214 114.233 26.9544 114.233 17.9901C114.233 9.02579 106.972 1.75879 98.0147 1.75879L17.9773 1.78091C9.09122 1.88472 1.94214 9.12371 1.94214 18.0177C1.94214 26.9118 9.09122 34.1508 17.9773 34.2546L98.0147 34.2236",
    fill: "#DC291E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6744 20.6936L27.7872 27.0051L35.1523 26.9919L36.2177 9.03943H27.4711L27.5949 17.0699H22.3716L22.4866 9.03943H13.7554L14.8363 27.0051H22.2036L22.292 20.6936H27.6744Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2019 20.7532V17.1317L38.9189 17.1538V20.7532H44.2019Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3054 20.7532L77.2701 17.1317H71.9893L71.9761 20.7532H77.3054Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2916 17.0699H55.8597L55.8995 13.944H69.0648L69.403 9.03943H47.2412L47.9905 26.9786H68.4348L68.7111 23.6071H55.7359L55.7845 20.6936H65.1634L65.2916 17.0699Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3491 9.03489H97.1926L97.1904 9.03047C101.974 9.01277 102.977 12.1719 102.964 13.9704C102.909 16.7888 101.642 18.3706 99.098 18.9237C102.356 19.2644 102.186 21.647 101.881 23.2154C101.567 24.899 100.468 26.9763 96.0852 26.9763H81.4168L80.3491 9.03489ZM91.7613 13.6209C93.0323 13.6209 94.4824 14.1407 94.4338 15.3685C94.3299 16.8508 93.0876 17.2313 91.5182 17.2313H88.9519L89.0248 13.6231L91.7613 13.6209ZM93.762 22.1182C93.6098 23.7545 91.9766 23.742 90.7121 23.7323L90.7119 23.7323C90.6174 23.7316 90.5249 23.7309 90.4353 23.7309H88.8438L88.8946 20.4125H91.3769C92.5838 20.4125 93.8968 20.6736 93.762 22.1248V22.1182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHebLogo);
export default __webpack_public_path__ + "static/media/heb_logo.4700602129b90f85471885d3106bb041.svg";
export { ForwardRef as ReactComponent };